import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'toFixedNum'
})
export class ToFixedNumPipe implements PipeTransform {

  transform(value: any, ...args: any[]): any {
    console.log('value Pipe'+ value)
    // let num = value.toFixed();
    return value;
  }

}
